import api from "api/axios";

export type ResourceType = "document" | "video";

export interface ResourceItem {
  id: number;
  title: string;
  description: string | null;
  tag: string | null;
  resource_type: ResourceType;
  url: string;
  embed_url: string | null;
  role_ids: number[];
  role_names: string[];
  is_enabled: boolean;
  archived_at: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface ResourceCreate {
  title: string;
  description?: string;
  tag?: string;
  resource_type: ResourceType;
  url: string;
  role_ids: number[];
}

export interface ResourceUpdate {
  title?: string;
  description?: string;
  tag?: string;
  resource_type?: ResourceType;
  url?: string;
  role_ids?: number[];
  is_enabled?: boolean;
}

function isAdmin(): boolean {
  return localStorage.getItem("authUserType") === "admin";
}

function resourcesApiBase(): string {
  return isAdmin() ? "/admin/resources" : "/employee/resources";
}

export async function listResources(includeArchived = false): Promise<ResourceItem[]> {
  const params = isAdmin() && includeArchived ? "?include_archived=true" : "";
  const res = await api.get(`${resourcesApiBase()}${params}`);
  return res.data;
}

export async function createResource(data: ResourceCreate): Promise<ResourceItem> {
  const res = await api.post("/admin/resources", data);
  return res.data;
}

export async function updateResource(id: number, data: ResourceUpdate): Promise<ResourceItem> {
  const res = await api.patch(`/admin/resources/${id}`, data);
  return res.data;
}

export async function archiveResource(id: number): Promise<ResourceItem> {
  const res = await api.post(`/admin/resources/${id}/archive`);
  return res.data;
}

export async function restoreResource(id: number): Promise<ResourceItem> {
  const res = await api.post(`/admin/resources/${id}/restore`);
  return res.data;
}

export async function deleteResource(id: number): Promise<void> {
  await api.delete(`/admin/resources/${id}`);
}
